const singleAdmitcardActions = {
  GENERATE_SINGLE_ADMITCARD: "GENERATE_SINGLE_ADMITCARD",
};

export default singleAdmitcardActions;
